export class AbstractApp {
    constructor(platform, icon, themeColor, supportedLanguages) {
        this.platform = platform;
        this.icon = icon;
        this.themeColor = themeColor;
        this.supportedLanguages = supportedLanguages;
        this.name = "";
        this.description = "Loading...";
        this.updateLauncherItems();
    }
    updateLauncherItems() {
        this.platform.setLauncherItems(this.computeLauncherItems());
    }
    computeLauncherItems() {
        return [{
                id: this.platform.appId,
                title: this.name,
                description: this.description,
                icon: this.icon,
                color: this.themeColor,
            }];
    }
}
//# sourceMappingURL=AbstractApp.js.map